export default __webpack_public_path__ + "static/media/AP_BUDGET_PRESENTATION_2023_24_v1-2.7d22b679.pdf";